import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@htx/environment';
import {
  DiscoveryOrganization,
  BdrsEntry,
  WalletEntry,
  DiscoveryOrganizationRequest,
  DiscoveryOrganizationUpdateRequest,
  BdrsMappingRequest
} from './infrastructure.model';

@Injectable({
  providedIn: 'root'
})
export class InfrastructureService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl = `${environment.backendUrl}/infrastructure`;

  // ── Discovery Service ──────────────────────────────────────────────────────

  getDiscoveryOrganizations(): Observable<DiscoveryOrganization[]> {
    return this.httpClient.get<DiscoveryOrganization[]>(`${this.baseUrl}/discovery/organizations`);
  }

  createDiscoveryOrganization(request: DiscoveryOrganizationRequest): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}/discovery/organizations`, request);
  }

  updateDiscoveryOrganization(
    bpnl: string,
    request: DiscoveryOrganizationUpdateRequest
  ): Observable<void> {
    return this.httpClient.patch<void>(
      `${this.baseUrl}/discovery/organizations/${encodeURIComponent(bpnl)}`,
      request
    );
  }

  deleteDiscoveryOrganization(bpnl: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.baseUrl}/discovery/organizations/${encodeURIComponent(bpnl)}`
    );
  }

  // ── BDRS ───────────────────────────────────────────────────────────────────

  getBdrsEntries(): Observable<BdrsEntry[]> {
    return this.httpClient.get<BdrsEntry[]>(`${this.baseUrl}/bdrs/entries`);
  }

  createBdrsEntry(request: BdrsMappingRequest): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}/bdrs/entries`, request);
  }

  updateBdrsEntry(bpn: string, request: BdrsMappingRequest): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/bdrs/entries/${encodeURIComponent(bpn)}`,
      request
    );
  }

  deleteBdrsEntry(bpn: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}/bdrs/entries/${encodeURIComponent(bpn)}`);
  }

  // ── DIM Wallet ─────────────────────────────────────────────────────────────

  getWalletEntries(): Observable<WalletEntry[]> {
    return this.httpClient.get<WalletEntry[]>(`${this.baseUrl}/wallet/entries`);
  }
}
